import { slateToMarkdown } from "../../slate-to-markdown";
export function handleTextTile({ tile, options }) {
    const content = tile.model.content;
    if (content.type !== "Text") {
        return undefined;
    }
    let textFormat = "Markdown";
    let result;
    switch (content.format) {
        case "slate":
            try {
                result = slateToMarkdown(content.text);
            }
            catch (error) {
                console.error("Error deserializing slate content:", error);
                result = content.text;
            }
            break;
        case "markdown":
            result = content.text;
            break;
        default:
            textFormat = content.format || "plain";
            result = content.text;
            break;
    }
    return options.minimal ? `\`\`\`text\n${result || ""}\n\`\`\``
        : `This tile contains the following ${textFormat} text content delimited below by a text code fence:` +
            `\n\n\`\`\`text\n${result || ""}\n\`\`\``;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGFuZGxlLXRleHQtdGlsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NoYXJlZC9haS1zdW1tYXJpemVyL3RpbGUtc3VtbWFyaXplcnMvaGFuZGxlLXRleHQtdGlsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0seUJBQXlCLENBQUM7QUFHMUQsTUFBTSxVQUFVLGNBQWMsQ0FBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQXFCO0lBQ2pFLE1BQU0sT0FBTyxHQUFRLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDO0lBQ3hDLElBQUksT0FBTyxDQUFDLElBQUksS0FBSyxNQUFNLEVBQUUsQ0FBQztRQUFDLE9BQU8sU0FBUyxDQUFDO0lBQUMsQ0FBQztJQUNsRCxJQUFJLFVBQVUsR0FBRyxVQUFVLENBQUM7SUFDNUIsSUFBSSxNQUFjLENBQUM7SUFDbkIsUUFBUSxPQUFPLENBQUMsTUFBTSxFQUFFLENBQUM7UUFDdkIsS0FBSyxPQUFPO1lBQ1YsSUFBSSxDQUFDO2dCQUNILE1BQU0sR0FBRyxlQUFlLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQ3pDLENBQUM7WUFBQyxPQUFPLEtBQUssRUFBRSxDQUFDO2dCQUNmLE9BQU8sQ0FBQyxLQUFLLENBQUMsb0NBQW9DLEVBQUUsS0FBSyxDQUFDLENBQUM7Z0JBQzNELE1BQU0sR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDO1lBQ3hCLENBQUM7WUFDRCxNQUFNO1FBRVIsS0FBSyxVQUFVO1lBQ2IsTUFBTSxHQUFHLE9BQU8sQ0FBQyxJQUFJLENBQUM7WUFDdEIsTUFBTTtRQUVSO1lBQ0UsVUFBVSxHQUFHLE9BQU8sQ0FBQyxNQUFNLElBQUksT0FBTyxDQUFDO1lBQ3ZDLE1BQU0sR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDO1lBQ3RCLE1BQU07SUFDVixDQUFDO0lBRUQsT0FBTyxPQUFPLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxlQUFlLE1BQU0sSUFBSSxFQUFFLFVBQVU7UUFDNUQsQ0FBQyxDQUFDLG9DQUFvQyxVQUFVLHFEQUFxRDtZQUNuRyxtQkFBbUIsTUFBTSxJQUFJLEVBQUUsVUFBVSxDQUFDO0FBQ2hELENBQUMifQ==